import React from 'react';
import { Link } from 'react-router-dom';
import { articlePath } from './routes';
import { coverSrc, formatArticleDate } from './articlesApi';

export const ArticleCover = ({ article, className = '' }) => (
  article.cover_url
    ? <img src={coverSrc(article.cover_url)} alt={article.title} loading="lazy" className={`w-full object-cover ${className}`} />
    : (
      // Sans image : visuel généré avec la catégorie et le titre
      <div className={`w-full bg-gradient-to-br from-yellow-500/30 via-gray-900 to-gray-950 flex flex-col justify-between p-4 ${className}`}>
        <span className="text-yellow-400 text-[11px] font-semibold uppercase tracking-wide">{article.category}</span>
        <span className="text-white/90 text-lg sm:text-xl font-bold leading-snug line-clamp-3">{article.title}</span>
      </div>
    )
);

export default function ArticleCard({ article }) {
  return (
    <article className="group bg-gray-900/80 border border-gray-800 hover:border-yellow-500/50 rounded-2xl overflow-hidden flex flex-col transition-colors">
      <Link to={articlePath(article.slug)} tabIndex={-1} aria-hidden="true">
        <ArticleCover article={article} className="aspect-[2/1] sm:aspect-[16/9]" />
      </Link>
      <div className="p-4 flex flex-col flex-1">
        <p className="text-xs text-gray-500 mb-1.5">
          <span className="text-yellow-400 font-medium">{article.category}</span> · {formatArticleDate(article.published_at)}
        </p>
        <h2 className="text-base sm:text-lg font-bold leading-snug mb-2">
          <Link to={articlePath(article.slug)} className="text-white group-hover:text-yellow-400">{article.title}</Link>
        </h2>
        <p className="text-sm text-gray-400 leading-relaxed flex-1">{article.excerpt}</p>
        <Link to={articlePath(article.slug)} className="mt-3 text-sm font-semibold text-yellow-400 hover:underline">Lire l'article →</Link>
      </div>
    </article>
  );
}
